export default __webpack_public_path__ + "static/media/covid.d8fd7810.png";